import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/survey-previews/$surveyId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/app/survey-previews/$surveyId/$languageId',
      params: { surveyId: params.surveyId, languageId: 'en' },
    })
  },
})
